import { render } from "./ExpertsTable.vue?vue&type=template&id=85c6d8fc&scoped=true"
import script from "./ExpertsTable.vue?vue&type=script&lang=js"
export * from "./ExpertsTable.vue?vue&type=script&lang=js"

import "./ExpertsTable.vue?vue&type=style&index=0&id=85c6d8fc&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85c6d8fc"]])

export default __exports__